import TravelGuideContainer from '../../../../components/containers/TravelGuideContainer';
import preloadCustomProps from '../../../utils/preloads/preloadTravelGuideProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'travel-guide-container',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: TravelGuideContainer
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
